import React from "react";
import Skinstore from "../assets/portfolio/apple.jpg";
import Newspaper from "../assets/portfolio/jcrew.jpg";
import Bluefly from "../assets/portfolio/tata.png";

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: Skinstore,
      name:"AppleTv+ Clone",
      link: 'https://apple-tv-clone-by-chetan.netlify.app/',
      repo: 'https://github.com/cs2812/AppleTV-Colne',
      text:`This website is a clone of “AppleTv+.com”
      This is my Individual Project. I used React, Chakra Ui, CSS, JavaScript, React Slick to make this project.
      I made a same catagory and all movies & Series related information wrap in a Carousel. I tryed to get same UI.
      `
    },
    {
      id: 2,
      src: Newspaper,
      name:"JCrew Clone",
      link: 'https://prakarshprasar.github.io/Project-3/',
      repo: 'https://github.com/Prakarshprasar/Project-3',
      text:`This website is a clone of “jcrew.com”. This is a Collaborative  Project, in which we implemented some cool functionalities.
      In this project I made Product ( Man, Woman, child Cloths ) page and gave functionality in it. 
      We used HTML, CSS, JavaScript to build this project.
      `
    },
    {
      id: 3,
      src: Bluefly,
      name:"Tata Cliq Clone",
      link: 'https://tata-cliq-clone.netlify.app/',
      repo: 'https://github.com/premsg1610/Unit-2-Project---Tata-Cliq',
      text:`This website is a clone of “tatacliq.com”. This is a Collaborative  Project, in which we implemented some cool functionalities.
       I made all Product page, product detail page, Payment page and gave functionality in it. 
      We used HTML, CSS, JavaScript to build this project. We used github to merge code together.
      `
    },
  
  ];

  return (
    <div
      name="projects"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen portfolio"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Projects
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src, link, repo,name,text }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg" style={{padding:"0.5rem"}}>
              <img
                src={src}
                alt="projects"
                className="rounded-md duration-200 hover:scale-105"
              />
              <div  style={{marginTop:"3%"}}>
              <h1 style={{color:"yellowgreen"}}>{name}</h1>
              </div>
              <div style={{marginTop:"3%"}}>{text}</div>
              <div className="flex items-center justify-center">
                
                <button className="w-1/2 px-6 py-3 m-2 duration-200 hover:scale-105" onClick={ () => window.open(link, '_blank')}>
                <p style={{border:"solid red",borderRadius:"10px"}}>Live</p>
                </button>
                <button className="w-1/2 px-6 py-3 m-2 duration-200 hover:scale-105" onClick={ () => window.open(repo, '_blank')}>
                <p style={{border:"solid red",borderRadius:"10px"}}>GitHub</p>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
